import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { formateDate, showStatus } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { RemediesDetails } from "../../services/remedise.services";
import { REMEDY_FIELDS } from "../../../../utils/Constants";

const ViewRemedy = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const breadcrumbs = [
    { title: "Dashboard", url: "/admin/dashboard" },
    { title: "Ecommerce", url: "/admin/remedies-management/remedies/list/1" },
    { title: "View Remedy", url: "" },
  ];
 

  useEffect(() => {
      RemediesDetails(params.id)
      .then((data) => {
        setShowDefault(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  
  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">View Remedy</h6>
              </div>
              {showdefault && Object.keys(showdefault)?.length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                        <tr>
                          <th>{t("Image")}</th>
                          <td>
                            <img
                              src={
                                showdefault && showdefault.image
                                  ? showdefault.image
                                  : "N/A"
                              }
                              alt="Remedy"
                              style={{ height: "100px" }}
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>Name</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.name ? showdefault.name : "N/A"}
                          </td>
                        </tr>
                         <tr>
                          <th>{t("faq.label_status")}</th>
                          <td>
                            {showdefault && showdefault?.status === 0 ? toHtml(showStatus(showdefault.status)) : toHtml(showStatus(showdefault.status))}
                          </td>
                        </tr>
                        <tr>
                          <th>Remedy Type</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.remedy_type_name ? showdefault.remedy_type_name : "N/A"}
                          </td>
                        </tr>
                        
                        <tr>
                          <th>Price</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.price ? `₹ ${showdefault.price.toFixed(2)}` : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>Discount (%) </th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.discount ? `${showdefault.discount.toFixed(0)}%` : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>Discounted Price</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.discounted_price ? `₹ ${showdefault.discounted_price.toFixed(2)}` : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>User Avg Rating</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.average_rating ? showdefault.average_rating : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>Rating</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.rating ? showdefault.rating : showdefault.average_rating ? showdefault.average_rating : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>Stock</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.stock ? showdefault.stock : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>Refundable</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.refundable ? "Yes" : "No"}
                          </td>
                        </tr>
                        
                        {(REMEDY_FIELDS[showdefault?.remedy_type_slug] || []).map((attribute, index) => (
                        <tr key={index}>
                          <th>{attribute.label}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.attributes && showdefault.attributes[attribute.name] ? showdefault.attributes[attribute.name] : "N/A"}
                          </td>
                        </tr>
                        ))}
                        
                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt  ? formateDate(showdefault.createdAt) : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_modified_date")}</th>
                          <td>
                            {showdefault && showdefault?.updatedAt ? formateDate(showdefault.updatedAt) : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    
                    <h6 className="main-content-label mb-3">Description:</h6>
                    <div className="text-capitalize"
                      dangerouslySetInnerHTML={{
                        __html:
                          showdefault && showdefault?.description ? showdefault.description : "N/A",
                      }}
                    ></div>

                    <div className="mt-5">
                      <button
                        className="btn ripple btn-dark"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("btn_back")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewRemedy;
